(function () {
  var popularCountryCodes = ['US', 'AU', 'GB', 'CA', 'DE', 'NL', 'FR', 'CH'];

  function prepareCountryList(disclosure) {
    if (!disclosure || disclosure.hasAttribute('data-country-search-prepared')) return;

    var list = disclosure.querySelector('[data-disclosure-list]');
    var options = disclosure.querySelectorAll('[data-country-option]');
    var emptyState = disclosure.querySelector('[data-country-search-empty]');

    if (!list || !options.length) return;

    var popularHeading = document.createElement('li');
    popularHeading.className = 'disclosure-list__group-heading';
    popularHeading.textContent = 'Popular countries';
    popularHeading.setAttribute('aria-hidden', 'true');
    popularHeading.setAttribute('data-country-group-heading', 'popular');

    var allHeading = document.createElement('li');
    allHeading.className = 'disclosure-list__group-heading';
    allHeading.textContent = 'All countries';
    allHeading.setAttribute('aria-hidden', 'true');
    allHeading.setAttribute('data-country-group-heading', 'all');

    list.insertBefore(popularHeading, options[0]);

    var firstNonPopularOption = null;
    for (var optionIndex = 0; optionIndex < options.length; optionIndex++) {
      if (popularCountryCodes.indexOf(options[optionIndex].getAttribute('data-country-code')) === -1) {
        firstNonPopularOption = options[optionIndex];
        break;
      }
    }

    for (var popularIndex = 0; popularIndex < popularCountryCodes.length; popularIndex++) {
      var popularOption = disclosure.querySelector(
        '[data-country-option][data-country-code="' + popularCountryCodes[popularIndex] + '"]'
      );
      if (popularOption) list.insertBefore(popularOption, firstNonPopularOption || emptyState);
    }

    list.insertBefore(allHeading, firstNonPopularOption || emptyState);
    disclosure.setAttribute('data-country-search-prepared', 'true');
  }

  function filterCountries(input) {
    var disclosure = input.closest('[data-disclosure-country]');
    prepareCountryList(disclosure);

    var options = disclosure ? disclosure.querySelectorAll('[data-country-option]') : [];
    var emptyState = disclosure ? disclosure.querySelector('[data-country-search-empty]') : null;
    var headings = disclosure ? disclosure.querySelectorAll('[data-country-group-heading]') : [];
    var term = input.value.trim().toLowerCase();
    var visibleCount = 0;
    var hasExactCodeMatch = false;

    for (var matchIndex = 0; matchIndex < options.length; matchIndex++) {
      var matchCountryCode = (options[matchIndex].getAttribute('data-country-code') || '').toLowerCase();
      var matchCurrencyCode = (options[matchIndex].getAttribute('data-country-currency') || '').toLowerCase();

      if (term && (matchCountryCode === term || matchCurrencyCode === term)) {
        hasExactCodeMatch = true;
        break;
      }
    }

    for (var optionIndex = 0; optionIndex < options.length; optionIndex++) {
      var option = options[optionIndex];
      var countryName = (option.getAttribute('data-country-name') || '').toLowerCase();
      var countryCode = (option.getAttribute('data-country-code') || '').toLowerCase();
      var currencyCode = (option.getAttribute('data-country-currency') || '').toLowerCase();
      var isExactCodeMatch = countryCode === term || currencyCode === term;
      var isPartialMatch =
        countryName.indexOf(term) !== -1 ||
        countryCode.indexOf(term) !== -1 ||
        currencyCode.indexOf(term) !== -1;
      var isVisible = !term || (hasExactCodeMatch ? isExactCodeMatch : isPartialMatch);

      option.hidden = !isVisible;
      if (isVisible) visibleCount++;
    }

    if (emptyState) emptyState.hidden = visibleCount !== 0;
    for (var headingIndex = 0; headingIndex < headings.length; headingIndex++) {
      headings[headingIndex].hidden = Boolean(term);
    }
  }

  function prepareCountryLists(root) {
    var disclosures = root.querySelectorAll('[data-disclosure-country]');
    for (var disclosureIndex = 0; disclosureIndex < disclosures.length; disclosureIndex++) {
      prepareCountryList(disclosures[disclosureIndex]);
    }
  }

  prepareCountryLists(document);

  document.addEventListener('shopify:section:load', function (event) {
    prepareCountryLists(event.target);
  });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-disclosure-country] [data-disclosure-toggle]');
    if (toggle) prepareCountryList(toggle.closest('[data-disclosure-country]'));
  });

  document.addEventListener('focusin', function (event) {
    if (event.target.matches('[data-country-search-input]')) {
      prepareCountryList(event.target.closest('[data-disclosure-country]'));
    }
  });

  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-country-search-input]')) filterCountries(event.target);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && event.target.matches('[data-country-search-input]') && event.target.value) {
      event.preventDefault();
      event.target.value = '';
      filterCountries(event.target);
    }
  });
})();
